import React from 'react';
import CatchphraseGame from './components/CatchphraseGame';

function App() {
  return (
    <CatchphraseGame />
  );
}

export default App;